export default __webpack_public_path__ + "static/media/CardThumb.c6c6a467.png";